import { Button, Flex, Modal, Select, Text } from "@mantine/core";
import { IBasicItem } from "@mctypes/global.types";
import React, { useMemo, useState } from "react";

const ConnectItemToGisModal: React.FC<{
  items: IBasicItem[];
  close: () => void;
  connectItemToGis: (item: IBasicItem) => void;
  placeholder: string;
  typeOfItemToLink: string;
  itemIdsToShow?: string[];
}> = ({ items, close, connectItemToGis, placeholder, typeOfItemToLink, itemIdsToShow }) => {
  const [selectedItemId, setSelectedItemId] = useState<string | null>(null);

  const filteredItems = useMemo(
    () => (itemIdsToShow == null ? items : items.filter((item) => itemIdsToShow.includes(item._id))),
    [items, itemIdsToShow],
  );

  const selectData = useMemo(
    () => filteredItems.map((item) => ({ label: String(item.displayValue ?? ""), value: item._id })),
    [filteredItems],
  );

  const selectedItem = useMemo(
    () => filteredItems.find((item) => item._id === selectedItemId) ?? null,
    [filteredItems, selectedItemId],
  );

  return (
    <Modal opened onClose={close} title="Koble til GIS" size="40vw">
      <div className="w-100">
        <Text size="sm" className="gray-700-text" mb="xs">
          <i className="fa fa-map-marker fa-fw" />
          {typeOfItemToLink} å linke til GIS
        </Text>
        <Select
          clearable
          searchable
          limit={100}
          data={selectData}
          placeholder={placeholder}
          nothingFoundMessage="Ingen valg funnet"
          value={selectedItemId}
          onChange={setSelectedItemId}
          maxDropdownHeight={220}
        />
      </div>
      <Flex justify="flex-end" mt="md" gap="xs">
        <Button onClick={close} variant="outline">
          Avbryt
        </Button>
        <Button
          onClick={() => selectedItem != null && connectItemToGis(selectedItem)}
          disabled={selectedItem == null}
          leftSection={<i className="fa fa-map-marker fa-fw" />}
        >
          Koble til GIS
        </Button>
      </Flex>
    </Modal>
  );
};

export default ConnectItemToGisModal;
